// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"App_shadowed__3jrTB"};